import bigProjectUrl from "../../../audio/big-project.mp3?url";
import bossProjectUrl from "../../../audio/boss-project.mp3?url";
import mapUrl from "../../../audio/map.mp3?url";
import rewardUrl from "../../../audio/reward2.mp3?url";
import smallMediumUrl from "../../../audio/small-medium-project2.mp3?url";
import stageSelectUrl from "../../../audio/stage-select.mp3?url";

export type GameBgmId =
  | "stageSelect"
  | "mapSelect"
  | "smallMediumCase"
  | "largeCase"
  | "bossCase"
  | "reward";

export type BgmTrackMeta = {
  id: GameBgmId;
  url: string;
  name: string;
  description: string;
};

export const BGM_TRACKS: readonly BgmTrackMeta[] = [
  { id: "stageSelect", url: stageSelectUrl, name: "ステージ選択", description: "プロジェクトを選ぶ前" },
  { id: "mapSelect", url: mapUrl, name: "マップ選択", description: "次のマスを選ぶ" },
  { id: "smallMediumCase", url: smallMediumUrl, name: "小規模・中規模PJ", description: "通常プロジェクト" },
  { id: "largeCase", url: bigProjectUrl, name: "大規模PJ", description: "大規模PJ" },
  { id: "bossCase", url: bossProjectUrl, name: "ボスPJ", description: "最終プロジェクト" },
  { id: "reward", url: rewardUrl, name: "報酬", description: "プロジェクトクリア後の選択" },
];
